import Offcanvas from 'react-bootstrap/Offcanvas';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';

import {siteDCAPType} from '../database/apiv2SiteAccessor';
import { parseDateTime } from '../timeFunctions/timeFns';

export default function SystemInfo(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const formatDate = (strDate) => {
    const baseDate = "Prior to June 2014"
    if (!strDate || strDate.length < 1)
      return baseDate
    const dt = parseDateTime (strDate, {zone: 'UTC'})
    if (dt.invalid)
      return baseDate
    const minDate = new Date ("2014-06-01")
    if (dt.toMillis() < minDate.getTime())
      return baseDate
    return strDate
  }
  const findDCAP = (site) => {
    const devs = site?.site_details?.devices
    if (Array.isArray (devs)) {
      const dcap = devs.find(d => d?.type === 'DCAP')
      return dcap?.device_id ?? ''
    }
    return ''
  }
  const capacity = (model) => {
    return model.match(/\d+$/) ?? '150'
  }

  const site = props.getActiveSite();
  const dcapModel = siteDCAPType(site) ?? 'Not Available'
  const dcapRadio = findDCAP(site)
  const mfgDate = formatDate (site?.site_details?.mfg_date ?? '')

  const field = (label, data, clickHandle=undefined) => {
    const cls = clickHandle ? 'rpt-edit' : 'site-label'
    return (
      <label className={"form-label w-50 "+cls} onClick={clickHandle}>{label}
        <input type="text" className="form-control display-style" 
            value={data} readOnly/>
      </label>
    )
  }
  return (
    <>
    {field("System Type", props?.range, handleShow)}
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>System Info</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {field("Device ID", dcapRadio)}
        {field("Model Number", dcapModel)}
        {field("Type", props.range)}
        {field('Capacity', capacity(dcapModel))}
        {field('Mfg Date', mfgDate)}
        {field("Mac Address", site?.site_details?.mac_address ?? '')}
        <Button variant='primary' onClick={()=>handleClose()}>Close</Button>
      </Offcanvas.Body>
    </Offcanvas>
    </>
  )
}
